import React from 'react';
import BrandLogo from './BrandLogo';

const LoadingScreen = () => {
  const gradient = 'linear-gradient(100deg, rgb(32, 216, 255) 0%, rgb(138, 92, 255) 50%, rgb(255, 78, 184) 100%)';

  return (
    <div className="main-body dark-theme-1">

      {/* Top shimmer bar (soft + blur) */}
      <div className="fixed top-0 left-0 z-50 w-full h-2 bg-gray-800/60 backdrop-blur-sm overflow-hidden">
        <div
          className="h-full w-1/3 animate-[smoothSlide_1.4s_linear_infinite] blur-[1px]"
          style={{ background: gradient }}
        />
      </div>

      <div className="main-header-s1">
        <BrandLogo alt="" style={{ height: '50px', width: '55px' }} />
      </div>

      <div className="body-content">
        <div className="flex justify-center items-center py-20 flex-auto">

          {/* Smooth Loader */}
          <div className="relative flex items-center justify-center">

            {/* Outer glow ring */}
            <div
              className="absolute w-16 h-16 rounded-full blur-xl animate-pulse"
              style={{ background: gradient, opacity: 0.35 }}
            ></div>

            {/* Spinner (gradient ring via conic-gradient + mask) */}
            <div
              className="w-10 h-10 rounded-full animate-spin"
              style={{
                background: `conic-gradient(from 0deg, rgb(32, 216, 255), rgb(138, 92, 255), rgb(255, 78, 184), transparent)`,
                WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
                mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
              }}
            ></div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;